
  const dataKey = "cod_proxy-shop-20250614_joseph-98147652@!*" 
//存入data
export function setData(data) {
  localStorage.setItem(dataKey, JSON.stringify(data));
}
//读取data  
export function getData() {
  return JSON.parse(localStorage.getItem(dataKey));
}
//清除data
export function removeData() {
  localStorage.removeItem(dataKey);
}  
  